export default __webpack_public_path__ + "static/tomasz_nadolny-61f9dbb9a4cd123f97930108b595b892.jpg";